import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton, CardImg, OverlayTrigger } from 'react-bootstrap';
import { context } from '../../AppContext';
import Locale from "../../../locale/Locale";
import Pager from "../components/Pager";
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as PSLib from 'poolside-js-lib';

export default class AlertList extends React.Component {

    state = {
        showClosedAlerts: false,
        alertsLoading: false,
        itemAlertsPage: 0,
        itemAlertsPageSize: 100,
        itemAlerts: null,
        itemAlertsCount: 0
    };

    componentDidMount() {
        if (this.state.itemAlerts === null) {
            this.updateAlerts();
        }
    }

    async updateAlerts() {
        this.setState({ 
            alertsLoading: true
        });
        let itemAlerts = await context.makeRequest("Professional.getAlerts", {
            adminApi: true,
            siteUuid: this.props.site.uuid,
            states: this.state.showClosedAlerts ? [ 'OPEN', 'CLOSED' ] : [ 'OPEN' ],
            page: this.state.itemAlertsPage,
            pageSize: this.state.itemAlertsPageSize
        });
        this.setState({ 
            itemAlerts: Array.isArray(itemAlerts.result) ? itemAlerts.result : itemAlerts.result?.items || [],
            itemAlertsCount: itemAlerts.result?.totalItemCount || 0,
            //page: Math.min(this.state.itemAlertsPage, Math.ceil(itemAlerts.result?.totalItemCount / this.state.itemAlertsPageSize)),
            alertsLoading: false
        });
    }

    render(props) {
        return (
            <div style={{  }}>
                { this.extraElement }
                <div style={{ }}>
                    <Button 
                        style={{ marginRight: 10 }}
                        onClick={ () => this.updateAlerts() }
                    >
                        <MdIcons.MdRefresh />{ Locale.gettext("Refresh") }
                    </Button>
                    <Button 
                        style={{ marginRight: 10 }}
                        type="checkbox" value={true} 
                        variant={ this.state.showClosedAlerts ? "primary" : "secondary" }
                        onClick={(val) => { 
                            this.setState({ showClosedAlerts: !this.state.showClosedAlerts }, () => {
                                this.updateAlerts();
                            });
                        }}
                    >{ Locale.gettext("Show Closed") }</Button>
                </div>
                <div style={{  }}>
                {
                    this.state.alertsLoading ? "Loading..." : 
                    this.state.itemAlerts?.length > 0 ? 
                        (
                            <div>
                                { this.state.itemAlertsCount > 0 ? (
                                    <div>
                                        <Pager 
                                            currentPage={ this.state.itemAlertsPage + 1 } 
                                            totalCount={ this.state.itemAlertsCount } 
                                            pageSize={ this.state.itemAlertsPageSize }
                                            onChange={(page) => {
                                                console.log("NEW PAGE " + page);
                                                this.setState({ itemAlertsPage: page - 1 }, () => {
                                                    this.updateAlerts();
                                                });
                                            }}
                                        />
                                    </div>
                                ) : null}
                                <table style={{ width: '100%', border: '1px solid' }}>
                                    <thead>
                                    <tr style={{ fontWeight: 'bold', border: '1px solid' }}>
                                        <td style={{ width: 150 }}>{ Locale.gettext("Created") + " / " + Locale.gettext("Updated") }</td>
                                        <td>{ Locale.gettext("State") }</td>
                                        <td>{ Locale.gettext("Error type") }</td>
                                        <td>{ Locale.gettext("Device / Body") }</td>
                                        <td>{ Locale.gettext("Details") }</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        { this.state.itemAlerts?.map(alrt => {
                                            let body = this.props.config.Config.BodiesOfWater?.find(itm => itm.UUID === alrt.bodyUuid);
                                            let device = this.props.config.Config.Devices?.find(dev => dev.UUID === alrt.entityUuid) || 
                                                        this.props.config.Config.BodiesOfWater?.find(dev => dev.UUID === alrt.entityUuid);
                                            if (alrt.type === "LONG_DISCONNECTED") {
                                                device = { Name: Locale.gettext("Attendant") };
                                            }
                                            let alertInfo = PSLib.Alert.getInfo(alrt, this.props.config);
                                            return (
                                                <tr 
                                                    style={{ border: '1px solid' }}
                                                    alt={ JSON.stringify(alrt.uuid) }
                                                    key={ JSON.stringify(alrt.uuid) }
                                                >
                                                    <td style={{ width: 150 }}>
                                                        { Locale.formatDateTime(alrt.created) }<br/>
                                                        { Locale.formatDateTime(alrt.updated) }
                                                    </td>
                                                    <td style={{  }}>
                                                        { alrt.state }
                                                    </td>
                                                    <td style={{ }}>
                                                        { alertInfo.card.title }
                                                    </td>
                                                    <td style={{ }} alt={ alrt.entityUuid }>
                                                        <OverlayTrigger
                                                            placement="bottom"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={ (overlayProps) => context.renderTooltip(alrt.entityUuid || alrt.bodyUuid, overlayProps) }
                                                        >
                                                            <div>{ device?.Name || body?.Name || Locale.gettext('Unknown') }</div>
                                                        </OverlayTrigger>
                                                    </td>
                                                    <td style={{ }}>
                                                        { alertInfo.card.description }<br/>
                                                        <div 
                                                            style={{ color: 'blue', fontWeight: 'bold', cursor: 'pointer' }}
                                                            onClick={ () => {
                                                                this.extraElement = (
                                                                    <Modal
                                                                        show={ true } 
                                                                        backdrop="static"
                                                                        onHide={ () => { this.extraElement = null; this.setState({}); } }
                                                                    >
                                                                        <Modal.Header closeButton >
                                                                            <Modal.Title>{ alertInfo.details.title || alertInfo.card.title }</Modal.Title>
                                                                        </Modal.Header>
                                                                        <Modal.Body>
                                                                            { alertInfo.details.description.map((line, index) => ( <React.Fragment key={ index }>{ line }<br/><br/></React.Fragment> )) }
                                                                        </Modal.Body>
                                                                        <Modal.Footer>
                                                                            <Button variant="secondary" onClick={ () => { this.extraElement = null; this.setState({}); }}>{ Locale.gettext("Close") }</Button>
                                                                        </Modal.Footer>
                                                                    </Modal>
                                                                );
                                                                this.setState({});
                                                            }}
                                                        >{ Locale.gettext("Details") }</div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : Locale.gettext("No alerts found")
                }
                </div>
            </div>
        );
    }
}